var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Artist Onboarding" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "pb-6 flex justify-between items-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "search name or email" },
                                on: { change: _vm.search },
                                model: {
                                  value: _vm.filter,
                                  callback: function($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder: "Select Status"
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.statusFilter,
                                    callback: function($$v) {
                                      _vm.statusFilter = $$v
                                    },
                                    expression: "statusFilter"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { value: "", label: "All" }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      value: "IN_REVIEW",
                                      label: "In Review"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      value: "APPROVED",
                                      label: "Approved"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      value: "REJECTED",
                                      label: "Rejected"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: { label: "Apply" },
                            on: { clicked: _vm.search }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            { staticClass: "p-2" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "sync"] },
                                on: { click: _vm.reset }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableApplication",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": {
                        background: true,
                        pageSizes: [20, 50, 100, 300, 500]
                      }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop.field,
                        attrs: {
                          prop: title.prop.field,
                          label: title.label,
                          sortable: "custom",
                          width: title.prop.width
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Status", "min-width": "140px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: _vm.statusBadgeClass(scope.row.status)
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.statusLabel(scope.row.status))
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.isSuperAdmin ||
                    _vm.isAdmin ||
                    _vm.isOps ||
                    _vm.isRecruitment
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            "min-width": "220px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "Detail",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "inline-block p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                                attrs: {
                                                  href:
                                                    "/#/artists/onboarding/" +
                                                    scope.row.id
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: { icon: ["fa", "eye"] }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.status === "IN_REVIEW"
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Approve",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "inline-block p-2 w-8 mr-2 rounded bg-green-500 hover:bg-green-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.approve(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "check"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.status === "IN_REVIEW"
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Reject",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "inline-block p-2 w-8 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openReject(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "times"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1127806534
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "rejectionModal",
          attrs: {
            isShowingModal: _vm.isShowingModalReject,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Submit Rejection",
            title: "Reject Application"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalReject = !_vm.isShowingModalReject
            },
            save: function($event) {
              return _vm.submitRejected()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("RejectionForm", {
                ref: "rejectionForm",
                attrs: {
                  "toggle-reset": _vm.isShowingModalReject,
                  "song-rejection": _vm.rejectionTarget,
                  "custom-submit": _vm.customReject
                },
                on: { "on-submit-rejection": _vm.onSubmitRejectionForm }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-914f094e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-914f094e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistContent/ArtistOnboarding.vue
// module id = null
// module chunks = 